module.exports = __webpack_public_path__ + "img/legal_representative_border.38d0eb76.svg";